import Button from 'components/base/Button';
import React, { ChangeEvent, useState } from 'react';
import { Alert, Form } from 'react-bootstrap';

const ResetPasswordForm = ({
  token,
  password,
  confirmPassword,
  setToken,
  setPassword,
  setConfirmPassword,
  handleSubmit,
  validated,
  errorMessage,
  message,
  isLoading,
  setErrorMessage
}: {
  token: number;
  password: string;
  confirmPassword: string;
  setToken: React.Dispatch<React.SetStateAction<number | undefined>>;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  setConfirmPassword: React.Dispatch<React.SetStateAction<string>>;
  handleSubmit: (e: any) => void;
  validated: boolean;
  errorMessage: string | null;
  message: string | null;
  isLoading: boolean;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [isValid, setIsValid] = useState(true);
  const handlePasswordChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setPassword(e.target.value);
    setIsValid(e.target.value === confirmPassword);
  };

  const handleConfirmPasswordChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setConfirmPassword(e.target.value);
    setIsValid(e.target.value === password);
  };
  return (
    <div className="text-center mb-6">
      <h4 className="text-1000">Reset new password</h4>
      <p className="text-700">Type your new password</p>
      <Form
        className="mt-5"
        onSubmit={handleSubmit}
        noValidate
        validated={validated}
      >
        <Form.Control
          className="mb-2"
          id="token"
          type="number"
          value={token}
          onChange={e => setToken(e.target.value as unknown as number)}
          placeholder="Token Sent your Email"
        />
        <Form.Control
          className="mb-2"
          id="password"
          type="password"
          name="password"
          value={password}
          onChange={handlePasswordChange}
          placeholder="Type new password"
        />
        <Form.Control
          className="mb-4"
          id="confirmPassword"
          type="password"
          name="confirmPassword"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          placeholder="Confirm new password"
        />
        {!isValid && <p className="text-red-500">Passwords do not match.</p>}
        <Button
          variant="primary"
          className="w-100"
          disabled={isLoading}
          onClick={handleSubmit}
          type="submit"
        >
          Set Password
        </Button>
      </Form>
      {message !== '' && <p className="fs-9 fw-bold">{message}</p>}
      {errorMessage !== '' && (
        <Alert
          variant="danger"
          className="text-white"
          onClose={() => setErrorMessage('')}
          dismissible
        >
          <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
          <p>{errorMessage}</p>
        </Alert>
      )}
    </div>
  );
};

export default ResetPasswordForm;
